module.exports = __webpack_public_path__ + "img/carat@2x.ea30161.jpg";